var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.col ? `col-md-${_vm.col}` : ''},[_c('div',{staticClass:"input_wrapper text_editor"},[_c('label',{staticClass:"custom_input_label"},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")]),_c('textarea',{attrs:{"required":_vm.required},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }